import { commonVars as a } from "./common.js";
import i from "../../../_styles/common/light.js";
function e(o) {
  const {
    scrollbarColor: r,
    scrollbarColorHover: l,
    scrollbarHeight: c,
    scrollbarWidth: s,
    scrollbarBorderRadius: t
  } = o;
  return Object.assign(Object.assign({}, a), {
    height: c,
    width: s,
    borderRadius: t,
    color: r,
    colorHover: l
  });
}
const n = {
  name: "Scrollbar",
  common: i,
  self: e
}, h = n;
export {
  h as default,
  e as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/scrollbar/styles/light.js
// module id = 180
// module chunks = 67